import { styled } from "theme/default/styled";

export const SFormLayoutLogo = styled.div<{ finOnWidth?: string }>`
  width: ${(props) => props.finOnWidth || "250px"};
  height: 80px;
  margin-top: ${(props) => (props.finOnWidth ? "25vh" : "100px")};
`;
